import defaultTheme from 'tailwindcss/defaultTheme';
// 1 = 0.25rem = 4px
// 4 = 1rem = 16px
const smallSizes = {
    // 0: 0 px; /* TAILWIND DEFAULT */
    // px: 1 px; /* TAILWIND DEFAULT */
    // 0.5: 0.125rem; /* 2px TAILWIND DEFAULT */
    // 1: 0.25rem; /* 4px TAILWIND DEFAULT */
    // 1.5: 0.375rem; /* 6px TAILWIND DEFAULT */
    // 2: 0.5rem; /* 8px TAILWIND DEFAULT */
    // 2.5: 0.625rem; /* 10px TAILWIND DEFAULT */
    // 3: 0.75rem; /* 12px TAILWIND DEFAULT */
    // 3.5: 0.875rem; /* 14px TAILWIND DEFAULT */
    // 4: 1rem; /* 16px TAILWIND DEFAULT */
    4.5: '1.125rem' /* 18px */,
    // 5: 1.25rem; /* 20px TAILWIND DEFAULT */
    5.5: '1.375rem' /* 22px */,
    // 6: 1.5rem; /* 24px TAILWIND DEFAULT */
    // 7: 1.75rem; /* 28px TAILWIND DEFAULT */
    7.5: '1.875rem' /* 30px */,
    // 8: 2rem; /* 32px TAILWIND DEFAULT */
    8.5: '2.125rem' /* 34px */,
    // 9: 2.25rem; /* 36px TAILWIND DEFAULT */
    // 10: 2.5rem; /* 40px TAILWIND DEFAULT */
    // 11: 2.75rem; /* 44px TAILWIND DEFAULT */
    // 12: 3rem; /* 48px TAILWIND DEFAULT */
    13: '3.25rem' /* 52px */,
    // 14: 3.5rem; /* 56px TAILWIND DEFAULT */
    15: '3.75rem' /* 60px */,
    // 16: 4rem; /* 64px TAILWIND DEFAULT */
    17: '4.25rem' /* 68px */,
    18: '4.5rem' /* 72px */,
    // 20: 5rem; /* 80px TAILWIND DEFAULT */
    22: '5.5rem' /* 88px */,
    // 24: 6rem; /* 96px TAILWIND DEFAULT */
    // 28: 7rem; /* 112px TAILWIND DEFAULT */
    30: '7.5rem' /* 120px */,
    // 32: 8rem; /* 128px TAILWIND DEFAULT */
    34: '8.5rem' /* 136px */,
    35: '8.75rem' /* 136px */,
    // 36: 9rem; /* 144px TAILWIND DEFAULT */
    // 40: 10rem; /* 160px TAILWIND DEFAULT */
    // 44: 11rem; /* 176px TAILWIND DEFAULT */
    47: '11.75rem' /* 188px */,
    // 48: 12rem; /* 192px TAILWIND DEFAULT */
    50: '12.5rem' /* 200px */,
    // 52: 13rem; /* 208px TAILWIND DEFAULT */
    // 56: 14rem; /* 224px TAILWIND DEFAULT */
    // 60: 15rem; /* 240px TAILWIND DEFAULT */
    // 64: 16rem; /* 256px TAILWIND DEFAULT */
    68: '17rem' /* 272px */,
    // 72: 18rem; /* 288px TAILWIND DEFAULT */
    75: '18.75rem' /* 300px */,
    79: '19.75rem' /* 316px */,
    // 80: 20rem; /* 320px TAILWIND DEFAULT */
    81: '20.25rem' /* 324px */,
    86: '21.5rem' /* 344px */,
    90: '22.5rem' /* 360px */
    // 96: 24rem; /* 384px TAILWIND DEFAULT */
};
const largeSizes = {
    // from to 96
    100: '25rem',
    107: '26.75rem',
    112: '28rem',
    128: '32rem',
    144: '36rem',
    152: '38rem',
    160: '40rem',
    168: '42rem',
    192: '48rem'
};
/*************
 *  other default sizes:
 */
// auto: auto; /* TAILWIND DEFAULT */
// 1/2: 50% ;/* TAILWIND DEFAULT */
// 1/3: 33.333333% ;/* TAILWIND DEFAULT */
// 2/3: 66.666667% ;/* TAILWIND DEFAULT */
// 1/4: 25% ;/* TAILWIND DEFAULT */
// 2/4: 50% ;/* TAILWIND DEFAULT */
// 3/4: 75% ;/* TAILWIND DEFAULT */
// 1/5: 20% ;/* TAILWIND DEFAULT */
// 2/5: 40% ;/* TAILWIND DEFAULT */
// 3/5: 60% ;/* TAILWIND DEFAULT */
// 4/5: 80% ;/* TAILWIND DEFAULT */
// 1/6: 16.666667% ;/* TAILWIND DEFAULT */
// 2/6: 33.333333% ;/* TAILWIND DEFAULT */
// 3/6: 50% ;/* TAILWIND DEFAULT */
// 4/6: 66.666667% ;/* TAILWIND DEFAULT */
// 5/6: 83.333333% ;/* TAILWIND DEFAULT */
// 1/12: 8.333333% ;/* TAILWIND DEFAULT */
// 2/12: 16.666667% ;/* TAILWIND DEFAULT */
// 3/12: 25% ;/* TAILWIND DEFAULT */
// 4/12: 33.333333% ;/* TAILWIND DEFAULT */
// 5/12: 41.666667% ;/* TAILWIND DEFAULT */
// 6/12: 50% ;/* TAILWIND DEFAULT */
// 7/12: 58.333333% ;/* TAILWIND DEFAULT */
// 8/12: 66.666667% ;/* TAILWIND DEFAULT */
// 9/12: 75% ;/* TAILWIND DEFAULT */
// 10/12: 83.333333% ;/* TAILWIND DEFAULT */
// 11/12: 91.666667% ;/* TAILWIND DEFAULT */
// full: 100% ;/* TAILWIND DEFAULT */
// screen: 100vw; /* TAILWIND DEFAULT */
// min: min-content; /* TAILWIND DEFAULT */
// max: max-content; /* TAILWIND DEFAULT */
// fit: fit-content; /* TAILWIND DEFAULT */
const allSizes = {
    ...smallSizes,
    ...largeSizes
};
const sizes = {
    height: {
        ...defaultTheme.height,
        ...allSizes
    },
    maxHeight: {
        ...defaultTheme.maxHeight,
        ...allSizes
    },
    maxWidth: {
        ...defaultTheme.maxWidth,
        ...allSizes
    },
    minHeight: {
        ...defaultTheme.minHeight,
        ...allSizes
    },
    minWidth: {
        ...defaultTheme.minWidth,
        ...allSizes
    },
    width: {
        ...defaultTheme.width,
        ...allSizes
    },
    // OTHER SIZES
    borderWidth: {
        ...defaultTheme.borderWidth,
        3: '3px'
    },
    inset: {
        ...defaultTheme.inset,
        '-4.5': '-1.125rem'
    },
    margin: {
        ...defaultTheme.margin,
        ...smallSizes
    },
    padding: {
        ...defaultTheme.padding,
        ...smallSizes,
        '1/2': '50%'
    },
    strokeWidth: {
        ...defaultTheme.strokeWidth,
        3: '3'
    }
};
export default sizes;
